import { serverTimestamp, setDoc } from 'firebase/firestore/lite'
import refs from '../refsLite'

export async function saveAssignmentDetail(assignmentDetail) {
  if (!assignmentDetail.created) {
    assignmentDetail.created = serverTimestamp()
  }
  await setDoc(refs.assignmentDetail(assignmentDetail.id), assignmentDetail)
}
